const setDateRange = (dateRange, customDateRange) => {
  if(dateRange === 'custom') {
    return [
      customDateRange.startDate.format('YYYY-MM-DD'),
      customDateRange.endDate.format('YYYY-MM-DD')
    ]
  }

  return dateRange
}

const queryBuilder = ({
  agentId,
  table,
  granularity,
  dateRange,
  customDateRange,
  chartType,
  channelNameToFilter,
  timeDimension,
  ...payload
}) => {
  const filters = []

  if(Array.isArray(payload.filters)) {
    filters.push(...payload.filters)
  }

  if(channelNameToFilter && channelNameToFilter !== 'all') {
    filters.push({
      'dimension': `${table}.channelname`,
      'operator': 'equals',
      'values': [
        channelNameToFilter
      ]
    })
  }

  const dimensions = []

  if(Array.isArray(payload.dimensions)) {
    payload.dimensions.forEach(dimension => {
      if(typeof dimension === 'string') {

        dimensions.push(`${table}.${dimension}`)

      }
    })
  }

  const measures = []

  if(Array.isArray(payload.measures)) {
    payload.measures.forEach(measure => {
      if(typeof measure === 'string') {

        measures.push(`${table}.${measure}`)

      }
    })
  }

  const timeDimensions = []

  if(Array.isArray(payload.timeDimensions)) {
    timeDimensions.push(...payload.timeDimensions)
  }

  if(
    agentId &&
    agentId !== 'default' &&
    process.env.IS_DEV !== 'true'
  ) {
    filters.push({
      'dimension': `${table}.agentid`,
      'operator': 'equals',
      'values': [
        agentId
      ]
    })
  }

  switch(chartType) {
    case 'table': {
      timeDimensions.push({
        'dimension': `${table}.${timeDimension}`,
        'dateRange': setDateRange(dateRange, customDateRange)
      })

      break
    }

    default: {
      timeDimensions.push({
        'dimension': `${table}.${timeDimension}`,
        'granularity': granularity,
        'dateRange': setDateRange(dateRange, customDateRange)
      })

      break
    }
  }

  const finalQuery = {
    measures,
    timeDimensions,
    dimensions,
    filters
  }

  return finalQuery
}

export default queryBuilder
